import { connectToParent, ErrorCode } from 'penpal'

let connection
if (typeof window !== 'undefined') {
  try {
    connection = connectToParent()
  } catch (e) {
    if (e.code == ErrorCode.NoIframeSrc) {
      // It's alright
    } else {
      throw e
    }
  }
}

async function callParentWindowFunction(funcName, args = []) {
  if (connection) {
    const parentWindow = await connection.promise
    if (parentWindow?.[funcName]) {
      parentWindow[funcName](...args)
    }
  }
}

export default function useParentWindow() {
  return {
    handshake: async () => callParentWindowFunction('handshake'),
    close: async () => callParentWindowFunction('close'),
    // FIXME: strictNullCheck temporary fix
    // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
    onData: async (data) => callParentWindowFunction('onData', [data]),
    onSuccess: async (...args) =>
      // FIXME: strictNullCheck temporary fix
      // @ts-expect-error TS(2345): Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      callParentWindowFunction('onSuccess', [...args]),
    onFlowRunComplete: async (flowRun) =>
      // FIXME: strictNullCheck temporary fix
      // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
      callParentWindowFunction('onFlowRunComplete', [flowRun]),
  }
}
